<template>
  <div class="checkout-coupon-code">
    <mdc-grid-container>
      <mdc-grid>
        <mdc-grid-cell :cols="12">
          <mdc-text-field
            v-model="value"
            :outlined="true"
            label="Type coupon code here"
            name="coupon-code"
            @input="onInput"
          />
        </mdc-grid-cell>
      </mdc-grid>
    </mdc-grid-container>
  </div>
</template>

<script>
import MdcGrid from '../material/Grid'
import MdcGridCell from '../material/GridCell'
import MdcGridContainer from '../material/GridContainer'

export default {
  components: {
    MdcGrid,
    MdcGridCell,
    MdcGridContainer
  },
  props: {
    value: {
      type: String,
      default: ''
    }
  },
  methods: {
    onInput (value) {
      this.$emit('input', value)
    }
  }
}
</script>

<style lang="scss">

</style>
